module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Natalie Daniels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Natalie Daniels is the pseudonym of a London based actor and screenwriter.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jlbwkD/tc-custom/9780062917492.jpg?1731883381931",
      "alt": "This image is the cover for the book Too Close"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Too Close\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("NOW AN AMC+ ORIGINAL SERIES STARRING EMILY WATSON")])]), _c('p', [_c('b', [_vm._v("A haunting, edge-of-your-seat psychological thriller about a woman who has been institutionalized for a heinous crime, and the psychiatrist assigned to her case who must uncover the truth beneath the madness.")])]), _c('p', [_c('i', [_vm._v("How close do you get before it’s too late…?")])]), _c('p', [_vm._v("Working as a dedicated forensic psychiatrist for many years, Emma is not shocked so easily. Then she is assigned to work with Connie, a wife and mother accused of a despicable crime. Connie is suffering from dissociative amnesia—or at least seems to be.")]), _c('p', [_vm._v("Now it is up to Emma to decide whether Connie can stand trial for her sins. But there is something about Connie that inexorably pulls Emma into her orbit. Perhaps it is the way she seems to see right through Emma, speaking to Emma’s deepest insecurities about her life, marriage, and her own tragic past. And soon Emma begins to understand how Connie’s complicated marriage and toxic relationship with her beautiful best friend Ness could have driven Connie to snap—or maybe, she is simply getting too close to a woman who is unforgivable…")]), _c('p', [_vm._v("Alternating between the two women’s points of view, before and after Connie’s breakdown, "), _c('i', [_vm._v("Too Close")]), _vm._v(" is a masterfully written page turner about the powerful—yet dangerous—closeness between women.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollinsPublishers\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0